import { Alert, Typography } from '@mui/material'
import ScheduleIcon from '@mui/icons-material/Schedule'
import { useLojaFechadaDelivery } from './use-loja-fechada-delivery'

export function AvisoLojaFechada(): JSX.Element | null {
  const estado = useLojaFechadaDelivery()

  if (!estado || estado.aberta) return null

  const { proxima, ofertavel } = estado

  return (
    <Alert severity="error" icon={<ScheduleIcon />} sx={{ mb: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        Loja fechada agora{proxima && ` · abre ${proxima.rotulo} às ${proxima.hora}`}
      </Typography>

      <Typography variant="body2">
        {ofertavel
          ? 'Você já pode fazer seu pedido agendado: escolha o horário no final do pedido.'
          : 'Os pedidos voltam quando a loja abrir.'}
      </Typography>
    </Alert>
  )
}
